import React, { useState, useEffect } from 'react';
import { Pane, Select, Text, TextInputField, Button } from 'evergreen-ui';
import moment from 'moment';

const calculateDates = (period) => {
    const today = moment();
    let startDate, endDate;

    console.log(`TimePeriodSelector - calculateDates for period: ${period}`);

    switch (period) {
        case 'Month to date':
            startDate = today.clone().startOf('month');
            endDate = today;
            break;
        case 'Quarter to date':
            startDate = today.clone().startOf('quarter');
            endDate = today;
            break;
        case 'Last quarter':
            startDate = today.clone().subtract(1, 'quarter').startOf('quarter');
            endDate = today.clone().subtract(1, 'quarter').endOf('quarter');
            break;
        case 'Year to date':
            startDate = today.clone().startOf('year');
            endDate = today;
            break;
        case 'Last year':
            startDate = today.clone().subtract(1, 'year').startOf('year');
            endDate = today.clone().subtract(1, 'year').endOf('year');
            break;
        case 'All time':
            startDate = moment('2000-01-01');
            endDate = today;
            break;
        default:
            startDate = today.clone().startOf('month');
            endDate = today;
    }

    const result = {
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD')
    };

    console.log(`TimePeriodSelector - calculated dates for ${period}:`, result);
    return result;
};

const TimePeriodSelector = ({
    selectedTimePeriod,
    setSelectedTimePeriod,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    showCustomDates = true
}) => {
    // Local state for date inputs
    const [tempStartDate, setTempStartDate] = useState(startDate);
    const [tempEndDate, setTempEndDate] = useState(endDate);

    // Debug logging for component props
    useEffect(() => {
        console.log('TimePeriodSelector - Props:', {
            selectedTimePeriod,
            startDate,
            endDate,
            showCustomDates,
            tempStartDate,
            tempEndDate
        });
    }, [selectedTimePeriod, startDate, endDate, showCustomDates, tempStartDate, tempEndDate]);

    const handlePeriodChange = (e) => {
        const newPeriod = e.target.value;
        console.log(`TimePeriodSelector - Period changed to: ${newPeriod}`);
        setSelectedTimePeriod(newPeriod);

        // Calculate and set the corresponding dates
        const dates = calculateDates(newPeriod);
        setStartDate(dates.startDate);
        setEndDate(dates.endDate);
        setTempStartDate(dates.startDate);
        setTempEndDate(dates.endDate);

        console.log('TimePeriodSelector - After period change:', {
            newPeriod,
            calculatedDates: dates,
            isCustom: newPeriod === 'custom'
        });
    };

    const handleCalculate = () => {
        console.log('TimePeriodSelector - Calculate clicked with custom dates:', {
            tempStartDate,
            tempEndDate
        });

        setStartDate(tempStartDate);
        setEndDate(tempEndDate);
        setSelectedTimePeriod('custom');

        console.log('TimePeriodSelector - After setting custom dates:', {
            startDate: tempStartDate,
            endDate: tempEndDate,
            selectedTimePeriod: 'custom'
        });
    };

    return (
        <Pane display="flex" alignItems="flex-end" gap={16} marginBottom={24}>
            {/* Time Period selector */}
            <Pane flex={1}>
                <Text fontWeight={500} marginBottom={8}>Time Period</Text>
                <Select
                    value={selectedTimePeriod}
                    onChange={handlePeriodChange}
                    width="100%"
                >
                    <option value="Month to date">Month to date</option>
                    <option value="Quarter to date">Quarter to date</option>
                    <option value="Last quarter">Last quarter</option>
                    <option value="Year to date">Year to date</option>
                    <option value="Last year">Last year</option>
                    <option value="All time">All time</option>
                </Select>
            </Pane>

            {showCustomDates && (
                <>
                    <Pane
                        marginX={16}
                        marginBottom={8}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Text color="muted" fontWeight={500} fontSize={14}>
                            OR
                        </Text>
                    </Pane>

                    <Pane flex={2} display="flex" alignItems="flex-end" gap={16}>
                        <TextInputField
                            type="date"
                            label="Start Date"
                            value={tempStartDate}
                            onChange={e => setTempStartDate(e.target.value)}
                            width="100%"
                            marginBottom={0}
                        />
                        <TextInputField
                            type="date"
                            label="End Date"
                            value={tempEndDate}
                            onChange={e => setTempEndDate(e.target.value)}
                            width="100%"
                            marginBottom={0}
                        />
                        <Button
                            appearance="primary"
                            onClick={handleCalculate}
                            height={32}
                            marginLeft={8}
                            paddingX={16}
                            style={{ backgroundColor: 'var(--maroon)', border: 'none' }}
                        >
                            Calculate
                        </Button>
                    </Pane>
                </>
            )}
        </Pane>
    );
};

export default TimePeriodSelector;
